import * as React from 'react';
import * as styles from './Slide.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Slide = function Slide(props) {
  var width = props.width,
    slide = props.slide,
    onClick = props.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: styles['slide-wrapper'],
    onClick: onClick,
    style: {
      width: "".concat(width, "px"),
      minWidth: "".concat(width, "px")
    },
    "data-testid": "Slide",
    children: slide
  });
};